import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
    const [currentMenu, setCurrentMenu] = useState({
        name: "Início",
        icon: "/images/icon/home.png",
        to: "/",
    });

    const updateMenu = (menuItem) => {
        setCurrentMenu(menuItem);
    };

    return (
        <NavigationContext.Provider value={{ currentMenu, updateMenu }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = () => useContext(NavigationContext);
